module.exports = __webpack_public_path__ + "img/voice.b7c151e7.gif";